export const LAUNCH_DARKLY_CONFIG = {
  dev: {
    launchdarklyClientId: '69898e7f77260a09eb01f9f1',
    launchdarklyEnvKey: 'test',
  },
  prod: {
    launchdarklyClientId: '69898e7f77260a09eb01f9f2',
    launchdarklyEnvKey: 'production',
  },
  stage: {
    launchdarklyClientId: '698996409122d209eb06212f',
    launchdarklyEnvKey: 'stage',
  },
};

const getEnvironment = () => {
  const host = location.host.toLowerCase();

  if (host.startsWith('dev') || host.startsWith('localhost')) {
    return 'dev';
  }

  if (host.startsWith('stage')) {
    return 'stage';
  }

  return 'prod';
};

export const getLDConfig = () => {
  const env = getEnvironment();

  return LAUNCH_DARKLY_CONFIG[env];
};
